<template>
    <div id="queryFlux">
        <div class="header">
            <ul>
                <li>
                    <div>总流量</div>
                    <span>{{ fluxMtoG(cardInfo.flowRate) }} G</span>
                </li>
                <li>
                    <div>已使用</div>
                    <span>{{ fluxMtoG(cardInfo.usedFlowRate) }} G</span>
                </li>
                <li>
                    <div>剩余流量</div>
                    <span>{{ decrease( fluxMtoG(cardInfo.flowRate), fluxMtoG(cardInfo.usedFlowRate)) }} G</span>
                </li>
            </ul>
        </div>
        <div class="simInfo">
            <h2>
                <span>SIM卡信息</span> 
                <span class="rightBtn">所有套餐</span>
            </h2>
            <ul>
                <li>
                    <div>运营商</div>
                    <span>{{ cardInfo.supplierTypeName + cardInfo.alias }}</span>
                </li> 
                <li>
                    <div>SIM卡状态</div>
                    <span>{{ cardInfo.cardStateName }}</span>
                </li>                               
                
                <li>
                    <div>当前套餐</div>
                    <div>
                        <span>{{ showCurrentPkg(cardInfo.simPackageList) }}</span>
                        <span class="more" @click="showAllPkg">更多</span>
                    </div>                    
                </li>
                <li>
                    <div>过期时间</div>
                    <span>{{ cardInfo.endTime }}</span>
                </li>
                <li>
                    <div>充值记录</div>
                    <a href="#/user/rechargeRecord">查看</a>
                </li>
            </ul>
        </div>
        <div class="fluxInfo">
            <h2>流量统计</h2>
            <mt-progress :value="cardInfo.usedFlowRate / cardInfo.flowRate * 100" :bar-height="10"></mt-progress>
            <div>
                <span class="green-defind">已使用：{{ fluxMtoG(cardInfo.usedFlowRate) }}G</span>
                <span>剩余：{{ decrease(fluxMtoG(cardInfo.flowRate), fluxMtoG(cardInfo.usedFlowRate)) }}G</span>
            </div>


            <mt-progress v-if="cardInfo.surplusFlowRateNoStart!='' && cardInfo.surplusFlowRateNoStart > 0" 
                :value="0" 
                :bar-height="10"></mt-progress>

            <div v-if="cardInfo.surplusFlowRateNoStart!='' && cardInfo.surplusFlowRateNoStart > 0">
                <span class="red-defind">未生效：{{ fluxMtoG(cardInfo.surplusFlowRateNoStart) }}G</span>
                <span >剩余：{{ fluxMtoG(cardInfo.surplusFlowRateNoStart) }}G</span>
            </div>
        </div>        
        <div class="footer" >
            <mt-button type="primary" size="large" @click="goToRechargePage">去充值</mt-button>
        </div>
        <div v-if="pkgListVisible" @click="pkgListVisible = false">
            <div class="shadowLayer"></div>
            <div class="pkgList">
                <h3>当前套餐</h3>
                <ul>
                    <li v-for="item in cardInfo.simPackageList" :key="item.id">
                        <span> {{ `${ item.packageName }` }}</span>
                        <span>过期时间： {{ item.endTime }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest} from '@/api/user.js'
// import {fluxMtoG} from '@/utils/utils.js'
export default {
    data(){
        return {
            cardInfo: {
                iccid: '',
                flowRate: '',
                endTime: '',
                usedFlowRate: '',
                surplusFlowRateNoStart:'',
                supplierTypeName: '',
                alias: '',
                cardState: '',
                cardStateName: '',
                basePkgGroupName: '',
                simPackageList: []
            },
            pkgListVisible: false        
        }        
    },
    methods: {
        // fluxMtoG,
        showAllPkg(){
            this.pkgListVisible = true;
        },
        showCurrentPkg(list){
            if(list.length > 0){
                return list[0].packageName;
            }else{
                return '-';
            }
        },
        getUserSimDetailHandler(){
            wxRequest("sim/detail", {iccid: this.$store.state.iccid}, "post").then(res => {
                if(res.data.code == 200){
                    for(var key in this.cardInfo){
                        this.cardInfo[key] = res.data.data[key]
                    }
                }
            })
        },
        goToRechargePage(){
            this.$router.push('/user/recharge');
        },
        IllusoryCardState(row){
            if(row.cardState >= 5 && row.cardState != 11){//异常或违禁等等
                return '正常';
            }else{
                return row.cardStateName;
            }
        },
    },
    created(){
        this.getUserSimDetailHandler();
    }
}
</script>

<style lang="less">
#queryFlux {
    height: 100%;
    background: #fbfbfb;
    .header {
        height: 172px;
        color: #fff;
        background: #26a2ff;
        ul {
            display: flex;
            justify-content: space-around;
            font-size: 16px;
            padding-top: 2em;
            div {
                margin-bottom: 8px;
            }
        }      

    }
    .simInfo,.fluxInfo {
        width: 82%;
        margin: 0 auto 16px;
        padding: 0 5% 8px;
        border-radius: 8px;
        background: #fff;
        border: 1px solid #f0f0f0;
        h2 {
            font-size: 14px;
            font-weight: bold;
            line-height: 36px;
            text-align: left;
            border-bottom: 1px solid #e5e5e5;
        }
        a {
            color: #26a2ff;
        }
    }
    .simInfo {
        margin-top: -78px;
        li {
            display: flex;
            justify-content: space-between;
            line-height: 28px;
            .more {
                color: #26a2ff;
                margin-left: 20px;
            }
        }
    }
    .fluxInfo {
        div {
            display: flex;
            justify-content: space-between;
        }
    }
    .pkgList {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1001;
        background: #fff;
        h3 {
            text-align: center;
            padding: 18px 0 7px;
            font-size: 18px;
        }
        ul {
            padding: 10px;
            li {
                height: 36px;
                line-height: 36px;
                display: flex;
                justify-content: space-between;
            }
        }
    }
    .footer {
        padding: 10px 10%;
    }
}

</style>
